import * as Shared from '@shared/lib';
import { create } from 'zustand';

interface LobbyState {
  setInvitedState: (state: Shared.LobbyInviteMessage | null) => void,
  setState: (state: Shared.LobbyStatusMessage) => void,
  invitedState: Shared.LobbyInviteMessage | null,
  state: Shared.LobbyStatusMessage | null,
}

export const useLobbyStore = create<LobbyState>()(
  (set) => ({
    setInvitedState: (invitedState) => set({ invitedState }),
    setState: (state) => set({ state }),
    invitedState: null,
    state: null,
  }),
);